export const INF_MODEL = 'infectious disease - working'

export interface IInput {
  label: string
  key: [string, string]
  var: string
  value: number
  step: number
  min: number
  max: number
}

export const inputs: IInput[] = [
  {
    label: 'Percent of population vaccinated',
    key: [INF_MODEL, 'Percent of population vaccinated'],
    var: 'p1',
    value: 0,
    step: 0.01,
    min: 0,
    max: 1,
  },
  {
    label: 'Vaccine effectiveness',
    key: [INF_MODEL, 'Vaccine effectiveness'],
    var: 'p2',
    value: 0.9,
    step: 0.01,
    min: 0,
    max: 1,
  },
  {
    label: 'incubation time',
    key: [INF_MODEL, 'incubation time'],
    var: 'p3',
    value: 3,
    step: 1,
    min: 0,
    max: 100,
  },
  {
    label: 'Duration of infection',
    key: [INF_MODEL, 'Duration of infection'],
    var: 'p4',
    value: 10,
    step: 1,
    min: 0,
    max: 100,
  },
  {
    label: 'Contact rate',
    key: [INF_MODEL, 'Contact rate'],
    var: 'p5',
    value: 10,
    step: 1,
    min: 0,
    max: 100,
  },
  {
    label: 'Mortality rate',
    key: [INF_MODEL, 'Mortality rate'],
    var: 'p6',
    value: 0.0015,
    step: 0.01,
    min: 0,
    max: 1,
  },
  {
    label: 'Probability of being infected with no vaccine',
    key: [INF_MODEL, 'Probability of being infected with no vaccine'],
    var: 'p7',
    value: 0.2,
    step: 0.01,
    min: 0,
    max: 1,
  },
]

export const emptyInput: IInput = {
  label: '-',
  key: [INF_MODEL, '_'],
  var: 'p0',
  value: 0,
  step: 1,
  min: 0,
  max: 1,
}
